// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4493":"51440c88","7871":"1d822493"}[chunkId] + ".chunk.css";
};